// src/i18n/index.js
import { createI18n } from 'vue-i18n';

const messages = {
  ru: {
    positions: {
      forward: 'Нападающий',
      defender: 'Защитник',
      goalkeeper: 'Вратарь',
      coach: 'Тренер',
      service: 'Сервис',
      // Множественные формы для списка игроков
      forwards: 'Нападающие',
      defenders: 'Защитники',
      goalkeepers: 'Вратари',
      coaches: 'Тренеры',
      services: 'Сервис',
    },
    skillLevels: {
      beginner: 'Начинающий',
      intermediate: 'Средний',
      experienced: 'Опытный',
    },
    today: 'Сегодня',
    tomorrow: 'Завтра',
    weekdays: {
      Sun: 'Вс',
      Mon: 'Пн',
      Tue: 'Вт',
      Wed: 'Ср',
      Thu: 'Чт',
      Fri: 'Пт',
      Sat: 'Сб',
    },
  },
  en: {
    positions: {
      forward: 'Forward',
      defender: 'Defender',
      goalkeeper: 'Goalkeeper',
      coach: 'Coach',
      service: 'Service',
      // Множественные формы для списка игроков
      forwards: 'Forwards',
      defenders: 'Defenders',
      goalkeepers: 'Goalkeepers',
      coaches: 'Coaches',
      services: 'Service',
    },
    skillLevels: {
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      experienced: 'Experienced',
    },
    today: 'Today',
    tomorrow: 'Tomorrow',
    weekdays: {
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
    },
  },
  // Добавьте другие языки по мере необходимости
};

const i18n = createI18n({
  locale: 'ru', // Начальный язык
  fallbackLocale: 'ru',
  messages,
});

export default i18n;